import { render, staticRenderFns } from "./NetWorth.vue?vue&type=template&id=fa35ea74&scoped=true&"
import script from "./NetWorth.vue?vue&type=script&lang=js&"
export * from "./NetWorth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa35ea74",
  null
  
)

export default component.exports